/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import * as TypeActions from '../store/folhaPonto/actionsTypes';
import BaseService from '../services/BaseService';
import FileService from '../services/FileService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';
import fileDownload from 'js-file-download';

function* findById({ id }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    
    const response = yield BaseService.get({ url: `folha-pontos/${id}` });
    if (response.data && response.data.arquivos && response.data.arquivos.length > 0) {
      const filledName = response.data.status === "NOT_VALID" ? "Documento mal preenchido" : "Documento preenchido";

      const arquivosToDownload = response.data.arquivos.map(a => ({
        ...a,
        nome: a.nome.indexOf('FILLED') > 0 ? filledName : "Documento em branco",
      }));

      response.data.arquivos = yield FileService.downloadArquivos(arquivosToDownload)
    }

    yield put({ type: TypeActions.FOLHA_PONTO_FIND_ONE_SUCCESS, data: response.data });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao carregar as informações!'
    });
  }
}

function* save({ data }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({ url: 'folha-pontos', data });
    yield put({
      type: TypeActions.FOLHA_PONTO_SAVE_SUCCESS,
      data: response.data
    });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações salvas com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao salvar as informações!'
    });
  }
}

function* update({ id, data }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.put({ url: `folha-pontos/${id}`, data });
    yield put({
      type: TypeActions.FOLHA_PONTO_UPDATE_SUCCESS,
      data: response.data
    });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações salvas com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao salvar as informações!'
    });
  }
}

function* folhaPontoUpdateStatus({ data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.patch({ url: `folha-pontos/${data.id}/status`, data });

    if (callback) {
      yield callback(response.data);
    }

    yield put({ type: TypeActions.FOLHA_PONTO_UPDATE_STATUS_SUCCESS });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações atualizadas com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao salvar as informações!'
    });
  }
}

function* folhaPontoReport({ filtro, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response =  yield BaseService.execute({ 
      url: 'folha-pontos/report',
      method: 'POST',
      data: filtro,
      options: {
        responseType: 'blob'
      }
    });
    yield fileDownload(response.data, 'Relatório Convocação.xlsx');
    yield callback(response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Relatório gerado com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao exportar o relatório!'
    });
  }
}

function* uploadFilledFolhaPonto({ folhaPontoId, arquivo, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    
    const data = FileService.getArquivosToUpload([arquivo])[0];
    const response = yield BaseService.patch({ url: `folha-pontos/${folhaPontoId}/documento`, data });
    let statusData = { id: folhaPontoId, status: 'RECEIVED', filled: true, dataAtualizacao: new Date(), arquivo };

    try {
      yield FileService.updateFile(response.data.url, arquivo.file);
      yield BaseService.patch({ url: `folha-pontos/${folhaPontoId}/documento/status`, data: statusData });
      yield callback(statusData);
      yield put({ type: ToastTypeActions.TOAST_MESSAGE_SUCCESS, message: 'Folha ponto preenchida enviada com sucesso!' });
      yield put({ type: LoaderTypeActions.LOADER_HIDE });
    } catch(error) {
      yield console.log(error);
      yield BaseService.patch({ url: `folha-pontos/${folhaPontoId}/documento/status`, data: { ...statusData, status: 'ERROR', filled: false } });
      yield callback({ ...statusData, status: 'ERROR', filled: false });
      yield put({ type: ToastTypeActions.TOAST_MESSAGE_ERROR, message: 'Erro ao enviar a folha de ponto preenchida!' });
      yield put({ type: LoaderTypeActions.LOADER_HIDE });
    }
    
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({ type: ToastTypeActions.TOAST_MESSAGE_ERROR, message: 'Erro ao enviar a folha de ponto preenchida!' });
  }
}

function* downloadFolhaPontoById({ folhaPontoId, tipoFolhaPonto }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.get({ url: `folha-pontos/${folhaPontoId}/documento/${tipoFolhaPonto}`, method: 'GET' });
    const responseFile = yield FileService.getFile(response.data.url);
    yield fileDownload(responseFile.data, response.data.nome);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Folha ponto gerado com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao exportar o relatório!'
    });
  }
}

function* deleteById({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    yield BaseService.delete({ url: `folha-pontos/${id}`});
    yield put({ type: TypeActions.FOLHA_PONTO_DELETE_SUCCESS, id });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações removidas com sucesso!'
    });
    yield callback();
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    if (error.response && error.response.status === 409) {
      yield put({
        type: ToastTypeActions.TOAST_MESSAGE_ERROR,
        message: error.response.data.mensagem
      });
    } else {
      yield put({
        type: ToastTypeActions.TOAST_MESSAGE_ERROR,
        message: 'Erro ao deletar!'
      });
    }
  }
}

export default function* watchAuth() {
  yield takeLatest(TypeActions.FOLHA_PONTO_SAVE, save);
  yield takeLatest(TypeActions.FOLHA_PONTO_UPDATE, update);
  yield takeLatest(TypeActions.FOLHA_PONTO_FIND_ONE, findById);
  yield takeLatest(TypeActions.FOLHA_PONTO_UPDATE_STATUS, folhaPontoUpdateStatus);
  yield takeLatest(TypeActions.FOLHA_PONTO_REPORT, folhaPontoReport);
  yield takeLatest(TypeActions.FOLHA_PONTO_DOWNLOAD, downloadFolhaPontoById);
  yield takeLatest(TypeActions.FOLHA_PONTO_UPLOAD_FILLED, uploadFilledFolhaPonto);
  yield takeLatest(TypeActions.FOLHA_PONTO_DELETE, deleteById);
}